module.exports = __webpack_public_path__ + "img/pointer_01.1562aaa7.png";